import React from 'react';
import { Table, Row, Col, Button, Dropdown, Pagination } from 'antd';
import { SettingOutlined, DownCircleOutlined, EditOutlined } from '@ant-design/icons';

import { getParamTable, _tableLogActivity, _fmtRupiah } from '../../../../../lib/Helper';

class Desktop extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
    };
  }

  componentDidMount() {
    this.props.fetchTable()
  }

  render() {
    const { table } = this.props.state
    const action = this.props.access.action

    return (
      <>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Table
              columns={[
                {
                  title: 'No',
                  dataIndex: 'rownum',
                  width: '2%',
                },
                {
                  title: 'Nama GTK',
                  render: (a, row) => <div>
                    {(row.tk_gelar_depan ? row.tk_gelar_depan : "") + (row.tk_nama ? row.tk_nama : "-") + (row.tk_gelar_belakang ? " " + row.tk_gelar_belakang : "")}
                    <br/>
                    <i>{row.jabatan_sekolah}</i>
                  </div>
                },
                {
                  title: 'Satuan Gaji Pokok',
                  render: (a, row) => "Rp. " + (row.gaji_pokok ? _fmtRupiah(row.gaji_pokok) : "0")
                },
                {
                  title: 'Tunjangan Masa Jabatan',
                  render: (a, row) => "Rp. " + (row.masa_kerja ? _fmtRupiah(row.masa_kerja) : "0")
                },
                {
                  title: 'Tunjangan Jabatan',
                  render: (a, row) => "Rp. " + (row.jabatan ? _fmtRupiah(row.jabatan) : "0")
                },
                {
                  title: 'Uang Makan',
                  render: (a, row) => "Rp. " + (row.uang_makan ? _fmtRupiah(row.uang_makan) : "0")
                },
                {
                  title: 'Keterangan',
                  render: (a, row) => row.keterangan ? row.keterangan : "-"
                },
                {
                  title: <SettingOutlined />,
                  align: "center",
                  key: 'operation',
                  width: '2%',
                  render: (a, row) => (!action.update ? "-" : <Dropdown trigger={['click']} menu={{
  items: [...(action.update ? [{
    key: 1,
    icon: <EditOutlined />,
    label: "Update",
    onClick: this.props.modalForm.bind(this, true, row)
  }] : [])]
}}>
                    <Button type="primary">Opsi <DownCircleOutlined style={{ fontSize: 11 }} /></Button>
                  </Dropdown>),
                },
                {
                  title: 'LogActivity',
                  key: 'operation',
                  width: '10%',
                  render: (a, row) => _tableLogActivity(row),
                },
              ]}
              rowKey={record => record.id}
              dataSource={table.data}
              pagination={false}
              loading={table.loading}
              size="small"
            />
          </Col>
          <Col xs={24} className="table-pagination">
            <Pagination
              size="small"
              current={table.pagination.current}
              pageSize={table.pagination.pageSize}
              total={table.pagination.total}
              showTotal={() => `Total ${table.pagination.total} items`}
              showSizeChanger
              onChange={(current, pageSize) => {
                const pagination = { current: current, pageSize: pageSize, total: table.pagination.total }
                const params = getParamTable("change", table, null, null, pagination)
                this.props.fetch(params)
              }}
            />
          </Col>
        </Row>
      </>
    )
  }
}

export default Desktop;
